import { useQuery, UseQueryOptions } from 'react-query';

import {Guid, ActiveNda } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useActiveNdaQuery (
	guid: Guid | undefined,
	options?: Omit<UseQueryOptions<ActiveNda, unknown, ActiveNda, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.LenderNda.Active(guid),
		() =>
			AxiosUtils.getResponseData<ActiveNda>(
				api.get(CerebroApiEndpoints.LenderNda.Root(guid))
			),
		options
	);
}
